<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240); margin-bottom: 35px"
      title="资产展示"
      sub-title=""
      @back="() => $router.back()"
    >
      <a-row type="flex">
        <a-statistic title="" :value="'名称：' + this.name" />
      </a-row>
    </a-page-header>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="编号">
              <a-input v-model="queryParam.number" placeholder="请输入" allowClear/>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="24">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="3" :sm="24">
            <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="rented" slot-scope="text">
        <a-tag :color="text ? 'red' : 'green'">
          {{ text ? '是' : '否' }}
        </a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      v-if="visible"
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { STable } from '@/components'
import {
  zone_property_cell_img_update,
  zone_property_cell_chops_list,
  zone_property_cell_chops_create,
  zone_property_cell_chops_delete
} from '@/api/zone_property_cell'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      name: '',
      corporations: [],
      corporation_id: null,
      tip: '',
      corList: [],
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      images_visible: false,
      confirmImagesLoading: false,
      visible: false,
      mdl: {},
      mdl_imgs: {},
      // 查询参数
      queryParam: {},
      drawer_columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' },
          align: 'center',
          width: 80
        },
        {
          title: '名称',
          dataIndex: 'corporation_name',
          ellipsis: true
        },
        {
          title: '开始时间',
          dataIndex: 'start_date',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '结束时间',
          dataIndex: 'end_date',
          ellipsis: true,
          align: 'center',
          width: 120
        }
      ],
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '编号',
          dataIndex: 'number',
          ellipsis: true
        },
        {
          title: '面积',
          dataIndex: 'area',
          align: 'center'
        },
        {
          title: '是否已出租',
          dataIndex: 'is_rented',
          align: 'center',
          scopedSlots: { customRender: 'rented' }
        },
        {
          width: 200,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return zone_property_cell_chops_list(Object.assign(parameter, this.queryParam, { zone_property_cell_id: this.$route.params.cell_id }))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      }
    }
  },
  created () {
    this.name = this.$route.query.record
  },
  methods: {
    onSelect (value) {
      this.queryParam.corporation_id = this.corList.filter((item) => (item.name === value) && item)[0].id

      console.log('onSelect', value, this.corList.filter((item) => (item.name === value) && item))
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleImagesCancel () {
      this.images_visible = false
      const form = this.$refs.createImagesModal.form
      form.resetFields() // 清理表单数据（可不做）
      this.$refs.table.refresh()
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleDelete (record) {
      zone_property_cell_chops_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    handleImagesOk () {
      const form = this.$refs.createImagesModal.form
      this.confirmImagesLoading = true
      form.validateFields((errors, values) => {
        if (values.imgs === undefined || values.imgs.length === 0) {
          this.confirmImagesLoading = false
          this.images_visible = false
          // 重置表单数据
          form.resetFields()
          // 刷新表格
          this.$refs.table.refresh()
          return
        }
        if (!errors) {
          values.imgs = values.imgs.split(',')
          values.img = undefined
          values.zone_property_cell_id = this.mdl_imgs.id
          zone_property_cell_img_update(values).then(res => {
            this.images_visible = false
            // 重置表单数据
            form.resetFields()
            // 刷新表格
            this.$refs.table.refresh()
          }).finally(() => {
            this.confirmImagesLoading = false
          })
        } else {
          this.confirmImagesLoading = false
        }
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          values.zone_property_cell_id = this.$route.params.cell_id
          zone_property_cell_chops_create(values).then(res => {
            this.visible = false
            // 重置表单数据
            form.resetFields()
            // 刷新表格
            this.$refs.table.refresh()
            console.log('创建成功------')
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  }
}
</script>
